import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "refetch"],
  _excluded2 = ["data", "refetch"];
const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery as useDFCQuery } from 'data-fetching-client';
import listingLibPerformanceTracking, { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { makeQuickFetchRequest } from 'framework-listing-lib/utils/quickFetch';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import { CRM_OBJECT_FRAGMENT } from 'framework-listing-lib/internal/graphql/fragments';
import useHasGraphQLCrmSearch from 'framework-listing-lib/internal/graphql/hooks/useHasGraphQLCrmSearch';
import { transformGraphQLResponseIntoCrmSearchResponse, getGraphQLVariables } from 'framework-listing-lib/internal/graphql/utils/graphql';
export const LISTING_LIB_CRM_SEARCH_QUERY = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"ListingLibCrmSearchQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}},\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Sort\"}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"associationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociationSpec\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"hasAssociationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Boolean\"}}},\"defaultValue\":{\"kind\":\"BooleanValue\",\"value\":false}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasMore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmObjectFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"total\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ListingLibCrmSearchQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "count"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "query"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "associationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssociationSpec"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hasAssociationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      },
      defaultValue: {
        kind: "BooleanValue",
        value: false
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "count"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "query"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasMore"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "offset"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "results"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CrmObjectFragment"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "total"
            }
          }]
        }
      }]
    }
  }].concat(CRM_OBJECT_FRAGMENT.definitions))
});
export const CRM_OBJECT_TYPE_FIELD_NAME = 'crmObjectType';
export const CRM_OBJECT_TYPE_QUERY = registerQuery({
  fieldName: CRM_OBJECT_TYPE_FIELD_NAME,
  args: ['fetcher', 'fetchParams', 'quickFetchName', 'removeAfterFetch'],
  fetcher({
    fetcher,
    fetchParams,
    quickFetchName,
    removeAfterFetch
  }) {
    const quickFetchArg = quickFetchName || `fetch-crm-objects-${fetchParams.objectTypeId}`;
    const crmSearchRequest = () => fetcher ? fetcher(fetchParams) : http.post('/crm-search/search', {
      data: fetchParams
    });
    let performanceTracking;
    if (quickFetchArg === `fetch-crm-objects-${fetchParams.objectTypeId}`) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    return makeQuickFetchRequest({
      makeRequestFn: crmSearchRequest,
      requestName: quickFetchArg,
      removeAfterFetch
    }).then(response => {
      Metrics.counter('crm-search-success', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      if (performanceTracking) {
        performanceTracking.markTimeEnd();
      }
      return response;
    }).catch(error => {
      Metrics.counter('crm-search-failure', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      throw error;
    });
  }
});
function useTrackPerfEnd(variables) {
  "use memo";

  const $ = _c(4);
  const initialQuickFetch = `fetch-crm-objects-${variables.fetchParams.objectTypeId}`;
  const quickFetchArg = variables.quickFetchName || initialQuickFetch;
  const shouldTrack = quickFetchArg === initialQuickFetch;
  let performanceTracking;
  if ($[0] !== shouldTrack) {
    if (shouldTrack) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    $[0] = shouldTrack;
    $[1] = performanceTracking;
  } else {
    performanceTracking = $[1];
  }
  let t0;
  if ($[2] !== performanceTracking) {
    t0 = () => {
      if (performanceTracking) {
        performanceTracking.markTimeEnd();
      }
    };
    $[2] = performanceTracking;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  performanceTracking;
  return t0;
}
export default function useFetchFromCRM(variables, options) {
  "use memo";

  const $ = _c(47);
  const hasGraphQLCrmSearch = useHasGraphQLCrmSearch();
  let t0;
  if ($[0] !== options) {
    t0 = options || {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = Object.assign({}, t0);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const incomingOptions = t1;
  let t2;
  bb0: {
    if (hasGraphQLCrmSearch) {
      let t3;
      if ($[4] !== incomingOptions) {
        t3 = Object.assign({}, incomingOptions, {
          skip: true
        });
        $[4] = incomingOptions;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = t3;
      break bb0;
    }
    t2 = incomingOptions;
  }
  const restOptions = t2;
  let t3;
  bb1: {
    if (hasGraphQLCrmSearch) {
      t3 = incomingOptions;
      break bb1;
    }
    let t4;
    if ($[6] !== incomingOptions) {
      t4 = Object.assign({}, incomingOptions, {
        skip: true
      });
      $[6] = incomingOptions;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = t4;
  }
  const graphQLOptions = t3;
  let t4;
  if ($[8] !== restOptions || $[9] !== variables) {
    t4 = Object.assign({
      variables
    }, restOptions);
    $[8] = restOptions;
    $[9] = variables;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = useDFCQuery(CRM_OBJECT_TYPE_QUERY, t4);
  let data;
  let refetchDFC;
  let rest;
  if ($[11] !== t5) {
    var _t = t5;
    ({
      data,
      refetch: refetchDFC
    } = _t);
    rest = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[11] = t5;
    $[12] = data;
    $[13] = refetchDFC;
    $[14] = rest;
  } else {
    data = $[12];
    refetchDFC = $[13];
    rest = $[14];
  }
  const trackPerfEnd = useTrackPerfEnd(variables);
  let t6;
  if ($[15] !== variables) {
    t6 = getGraphQLVariables(variables);
    $[15] = variables;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== trackPerfEnd || $[18] !== variables) {
    t7 = () => {
      Metrics.counter("crm-search-graphql-success", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
      trackPerfEnd();
    };
    $[17] = trackPerfEnd;
    $[18] = variables;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== variables) {
    t8 = () => {
      Metrics.counter("crm-search-graphql-failure", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
    };
    $[20] = variables;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== graphQLOptions || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = Object.assign({
      variables: t6,
      errorPolicy: "all",
      returnPartialData: true
    }, graphQLOptions, {
      onCompleted: t7,
      onError: t8
    });
    $[22] = graphQLOptions;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = useQuery(LISTING_LIB_CRM_SEARCH_QUERY, t9);
  let graphQLData;
  let refetchGraphQL;
  let restGraphQL;
  if ($[27] !== t10) {
    var _t2 = t10;
    ({
      data: graphQLData,
      refetch: refetchGraphQL
    } = _t2);
    restGraphQL = _objectWithoutPropertiesLoose(_t2, _excluded2);
    _t2;
    $[27] = t10;
    $[28] = graphQLData;
    $[29] = refetchGraphQL;
    $[30] = restGraphQL;
  } else {
    graphQLData = $[28];
    refetchGraphQL = $[29];
    restGraphQL = $[30];
  }
  let t11;
  if ($[31] !== hasGraphQLCrmSearch || $[32] !== refetchDFC || $[33] !== refetchGraphQL || $[34] !== variables) {
    t11 = refetchVariables => {
      const finalQueryVariables = refetchVariables || variables;
      if (hasGraphQLCrmSearch) {
        return refetchGraphQL(getGraphQLVariables(finalQueryVariables));
      }
      return refetchDFC(finalQueryVariables);
    };
    $[31] = hasGraphQLCrmSearch;
    $[32] = refetchDFC;
    $[33] = refetchGraphQL;
    $[34] = variables;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const refetch = t11;
  if (hasGraphQLCrmSearch) {
    let t12;
    if ($[36] !== graphQLData || $[37] !== variables.fetchParams.objectTypeId) {
      t12 = transformGraphQLResponseIntoCrmSearchResponse(graphQLData, variables.fetchParams.objectTypeId);
      $[36] = graphQLData;
      $[37] = variables.fetchParams.objectTypeId;
      $[38] = t12;
    } else {
      t12 = $[38];
    }
    let t13;
    if ($[39] !== refetch || $[40] !== restGraphQL || $[41] !== t12) {
      t13 = Object.assign({
        data: t12,
        refetch
      }, restGraphQL);
      $[39] = refetch;
      $[40] = restGraphQL;
      $[41] = t12;
      $[42] = t13;
    } else {
      t13 = $[42];
    }
    return t13;
  }
  const t12 = data && CRM_OBJECT_TYPE_FIELD_NAME in data ? data[CRM_OBJECT_TYPE_FIELD_NAME] : undefined;
  let t13;
  if ($[43] !== refetch || $[44] !== rest || $[45] !== t12) {
    t13 = Object.assign({
      data: t12,
      refetch
    }, rest);
    $[43] = refetch;
    $[44] = rest;
    $[45] = t12;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  return t13;
}